<template>
    <div>
        <stickyNav v-if="enableStickyNav" />
         <section class="unicard-bg">
            <div class="container pt-md-5">
                <div class="pt-5">
                    <div class="col-lg-8 pt-5">
                        <div class="row pt-5">
                            <h3 class="display-2 mt-5">CREATE YOUR <br>UNIQUE CODE
                            </h3>
                            <p class="lead text-dark mt-2">With our UNICARD, you can create your own unique <br>code to use across all telecommunications
                                networks
                            </p>
                        </div>
                    </div>
                    <!-- <div class="btn-wrapper mt-4">
                        <router-link to="/login" class="btn btn-info">
                            Download App
                        </router-link>
                    </div> -->
                </div>
            </div>
        </section>

        <section class="pb-5 my-5 px-lg-0 px-4">
            <div class="container">
                <div class="text-center justify-content-center">
                    <div class="col-lg-12">
                        <h2 class="display-3 text-dark">Customer Accessibility</h2>
                        <p class="lead mb-5">Recharging all networks</p>
                    </div>
                </div>
                <div class="row row-grid align-items-center pb-md-5">
                    <div class="col-md-6 order-md-2" data-aos="fade-left" data-aos-easing="ease-out-cubic" data-aos-duration="1000">
                        <div class="pl-md-5">
                            <div class="mb-4">
                                <img src="img/icons/common/enterprise.svg" class="img-fluid">
                            </div>
                            <p class="lead">Your unique code is able to recharge all networks. Generate code to print and sell to your customers
                            </p>
                             <p class="lead">As a Merchant/Reseller, you get to generate your code when you log in your dashboard, download the codes as log (Csb).Direct (end) users generate and get their in virtual printable formats (pdf)
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 order-md-1">
                        <img src="img/theme/unicard-hero.png" class="img-fluid rounded shadow-lg floating">
                    </div>
                </div>
            </div>
        </section>

       <section class="values-section py-5">
            <div class="container">
                <div class="container">
                <div class="row text-center justify-content-center">
                    <div class="col-lg-10">
                        <h2 class="display-3 text-dark">Features</h2>
                        <p class="lead text-dark">Compatible with all networks</p>
                    </div>
                </div>
                <div class="row row-grid mt-5 text-center">
                    <div class="col-lg-4">
                        <div class="mb-4">
                            <img src="img/icons/common/good.svg" class="img-fluid">
                        </div>
                        <h5 class="text-dark mt-3">Printable</h5>
                        <p class="mt-3 lead-2">The generated codes are printable and used for sales (merchandise)</p>
                    </div>
                    <div class="col-lg-4">
                        <div class="mb-4">
                            <img src="img/icons/common/good.svg" class="img-fluid">
                        </div>
                        <h5 class="text-dark mt-3">Easy to Use</h5>
                        <p class="mt-3 lead-2">The unique codes are easy to generate and use for your customers</p>
                    </div>
                    <div class="col-lg-4">
                        <div class="mb-4">
                            <img src="img/icons/common/good.svg" class="img-fluid">
                        </div>
                        <h5 class="text-dark mt-3">Direct to Use</h5>
                        <p class="mt-3 lead-2">The codes are direct to recharge, once the quantity of airtime is purchased, transaction takes place (on all networks)</p>
                    </div>
                </div>
                </div>
            </div>
        </section>

        <section class="section bg-white pt-md-5 px-lg-0 px-4">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 pr-lg-5">
                        <div class="card bg-code shadow text-white border-0 pt-4 pb-2">

                        <highlightjs langauge="js" :code="code" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="pl-lg-5">
                            <div class="mb-4">
                                <img src="img/icons/common/access.svg" class="img-fluid">
                            </div>
                            <h3>All you need to build</h3>
                            <p class="lead my-2">Integrate our APIs</p>
                            <p>We have documented a set of developer tools that will make it easier for you to learn how to work with our APIs. 
                                These resources will help you build faster and test your applications before you deploy them to your users.</p>
                            <base-button tag="a" href="#" type="primary" class="mt-3">
                                Learn more
                            </base-button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>


<script>
import StickyNav from '../../layout/StickyHeader';

export default {
  name: "enterprise",
  components: {
    StickyNav,
  },
  data() {
        return {
        enableStickyNav: null,
        code: '# import package \nimport topupbox \n \n#initialize SDK \nusername = "YOUR_USERNAME" \n \n# Initialize a service e.g. airtime \n airtime = topupbox.AIRTIME \n \nresponse = airtime.send([{ \n  beneficiary: "+2547XXXXXXXX", \n  amount: "200" \n}]) \n \nprint(response)'
        }
    },
    mounted() {
        // console.log('Index page created')
        // console.log('Sticky Nav mounted')
        window.addEventListener('scroll', this.handleNavDisplay)
    },
    // created() {},
    destroyed() {
        window.addEventListener('scroll', this.handleNavDisplay)
    },
    methods: {
        handleNavDisplay() {
        var y = window.scrollY
        if (y > 100 && !this.enableStickyNav) {
            // console.log ('Display New Menu')
            this.enableStickyNav = true
        } else if (y < 100 && this.enableStickyNav) {
            // console.log('Hide sticky Nav')
            this.enableStickyNav = false
        }
        }
    }
};
</script>
